import type { IInstagramPostDetail } from "../../../../../types/models/instagram-post-details.models.types";
import type { IInstagramUserProfile } from "../../../../../types/models/instagram-user-profile.models.types";
import type { IPost } from "../../../../../types/models/post.models.types";
import type { ISocial } from "../../../../../types/models/social.models.types";
import { useGetHttp } from "../../../http.hook";


export interface IPostDetail {
  instagramPostDetail: IInstagramPostDetail;
  instagramUserProfile: IInstagramUserProfile;
  social: ISocial;
  post: IPost | null;
}

export function useGetInstagramPostDetailsAdminHttp() {
  return useGetHttp<IPostDetail>({
    path: "/admin/campaigns/:campaignId/utils/instagram/post-details",
  });
}
